import React from 'react';
import { Container, Row, Col } from 'reactstrap';

import { Layout } from '../../components/Layout/Layout';
import { SEO } from '../../components/seo';
import { UnlayoutedPage } from '../../components/pages/UnlayoutedPage';
import { SvgRounedBottom } from '../../components/shapes/SvgRounedBottom';

// Import content
import {
  AccessControlRules,
  IdentificationMedia,
  LockTypes,
} from '../../content/pages/zutritt';
import { routes } from '../../content/pages/sicherheitstechnik/routes';

const {
  children: { zutritt },
} = routes;

export default () => (
  <Layout>
    <SEO title={zutritt.title} keywords={zutritt.keywords} />
    <UnlayoutedPage>
      <Container fluid className="bg-dark py-5 px-md-5 px-lg-7">
        <Row>
          <Col xs="12">
            <h1 className="display-2 text-primary text-center mb-3 text-break">
              {zutritt.text}
            </h1>
          </Col>
        </Row>
        <Row>
          <Col xs="12">
            <p className="lead text-center text-light">{zutritt.desc}</p>
          </Col>
        </Row>
      </Container>

      <SvgRounedBottom color="dark" className="w-100" bezierShift={0.25} />

      <AccessControlRules />
      <LockTypes />
      <IdentificationMedia />
    </UnlayoutedPage>
  </Layout>
);
